import { Dispatch, ReactNode, SetStateAction, useEffect, useState } from "react"
import IconResizer from "../icon/IconResizer"
import EyeIcon from "../icon/EyeIcon"
import EyeSlashIcon from "../icon/EyeSlashIcon"

interface TextFieldProps {
    label?: string | undefined
    placeholder: string
    type: "text" | "password"
    children?: ReactNode
    width?: number | undefined | "100%"
    inputState: [string, Dispatch<SetStateAction<string>>]
    onPasswordValid?: () => void
    onPasswordInvalid?: () => void
    strengthControl?: boolean
    onEnter?: () => void
}

function TextField(props: TextFieldProps) {
    const [showPassword, setShowPasssword] = useState(false)

    const [containsSpecialChart, setContainsSpecialChar] =
        useState<boolean>(false)
    const [hasMinLength, setHasMinLength] = useState<boolean>(false)
    const [containsUppercase, setContainsUppercase] = useState<boolean>(false)
    const [containsLowercase, setContainsLowercase] = useState<boolean>(false)
    const [containsNumber, setContainsNumber] = useState<boolean>(false)

    function valid() {
        return (
            containsSpecialChart &&
            hasMinLength &&
            containsUppercase &&
            containsLowercase &&
            containsNumber
        )
    }

    useEffect(() => {
        if (
            props.type === "password" &&
            props.strengthControl !== undefined &&
            props.strengthControl
        ) {
            if (valid() && props.onPasswordValid) props.onPasswordValid()
            else if (!valid() && props.onPasswordInvalid)
                props.onPasswordInvalid()
        }
    }, [
        containsSpecialChart,
        hasMinLength,
        containsUppercase,
        containsLowercase,
        containsNumber
    ])

    const isAnyUpper = (str: string) => /\p{Lu}/u.test(str)
    const isAnyLower = (str: string) => /\p{Ll}/u.test(str)
    const isAnyNumber = (str: string) => /\d/.test(str)
    function containsUpper(str: string) {
        for (const char of str) {
            if (isAnyUpper(char)) return true
        }
        return false
    }
    function containsLower(str: string) {
        for (const char of str) {
            if (isAnyLower(char)) return true
        }
        return false
    }
    function containsNbr(str: string) {
        for (const char of str) {
            if (isAnyNumber(char)) return true
        }
        return false
    }

    useEffect(() => {
        if (
            props.type === "password" &&
            props.strengthControl !== undefined &&
            props.strengthControl
        ) {
            const format: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/
            setContainsSpecialChar(format.test(props.inputState[0]))
            setHasMinLength(props.inputState[0].length >= 8)
            setContainsUppercase(containsUpper(props.inputState[0]))
            setContainsLowercase(containsLower(props.inputState[0]))
            setContainsNumber(containsNbr(props.inputState[0]))
        }
    }, [props.inputState[0]])

    return (
        <div
            style={{
                maxWidth: "100%",
                width: props.width === undefined ? 600 : props.width
            }}
            className={"flex flex-col space-y-2"}>
            {props.label && (
                <div className={"flex w-full"}>
                    <div className={"font-bold"}>{props.label}</div>
                    {props.children && (
                        <div className={"ml-auto"}>{props.children}</div>
                    )}
                </div>
            )}
            <div
                className={
                    props.type === "password"
                        ? "flex border-neutral-400 focus:border-blue-600 rounded border items-center"
                        : ""
                }>
                <input
                    onKeyDown={e => {
                        if(props.onEnter && (e.key === 'Enter' || e.keyCode === 13))
                            props.onEnter()
                    }}
                    value={props.inputState[0]}
                    onChange={(e) => props.inputState[1](e.target.value)}
                    className={
                        props.type === "password"
                            ? "w-full border-none focus:border-none rounded"
                            : "w-full border-neutral-400 focus:border-blue-600 rounded"
                    }
                    type={
                        props.type === "password"
                            ? showPassword
                                ? "text"
                                : "password"
                            : props.type
                    }
                    placeholder={props.placeholder}
                />
                {props.type === "password" && (
                    <div
                        onClick={() => setShowPasssword(!showPassword)}
                        className={
                            "p-1 m-1 cursor-pointer hover:bg-neutral-300 rounded-full"
                        }>
                        <IconResizer size={20} color={"text-black"}>
                            {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
                        </IconResizer>
                    </div>
                )}
            </div>
            {props.type === "password" &&
                props.strengthControl !== undefined &&
                props.strengthControl && (
                    <div className={"flex flex-col space-y-0"}>
                        <div
                            className={
                                "text-sm " +
                                (hasMinLength
                                    ? "text-emerald-600"
                                    : "text-rose-600")
                            }>
                            8 Zeichen lang
                        </div>
                        <div
                            className={
                                "text-sm " +
                                (containsSpecialChart
                                    ? "text-emerald-600"
                                    : "text-rose-600")
                            }>
                            Mind. 1 Sonderzeichen
                        </div>
                        <div
                            className={
                                "text-sm " +
                                (containsUppercase
                                    ? "text-emerald-600"
                                    : "text-rose-600")
                            }>
                            Mind. 1 Großbuchstabe
                        </div>
                        <div
                            className={
                                "text-sm " +
                                (containsLowercase
                                    ? "text-emerald-600"
                                    : "text-rose-600")
                            }>
                            Mind. 1 Kleinbuchstabe
                        </div>
                        <div
                            className={
                                "text-sm " +
                                (containsNumber
                                    ? "text-emerald-600"
                                    : "text-rose-600")
                            }>
                            Mind. 1 Ziffer
                        </div>
                    </div>
                )}
        </div>
    )
}

export default TextField
